<template lang="pug">
md-layout(md-column='')
  // Create license
  router-link(to='/license/new')
    md-button#btn-add-license.md-fab.md-fab-bottom-right.md-icon-button(md-theme='blue')
      md-icon(md-iconset="fa fa-plus")

  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Licenses', :nav='nav')
    // License List
    license-table#licenses
</template>

<script>
  import licenseTable from '../../shared-components/license/LicenseTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    name: 'LicenseList',
    components: {
      licenseTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Licenses' }
        ]
      },
    }

  };
</script>

<style lang="scss" scoped>
  #licenses {
    margin: 15px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  .on-left {
    margin-top: -8px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/license/list.vue